// extracted by mini-css-extract-plugin
module.exports = {"table_container":"TableComponent_table_container__DBf1u","table":"TableComponent_table__K3Z3V"};